/**
 * Country Phone Data
 * 
 * International phone number formats with country codes, flags, and masks
 * 
 * @package betbeast
 */

(function() {
    'use strict';

    /**
     * Country phone data with flags and masks
     * Format: 'COUNTRY_CODE': { flag: 'emoji', code: '+XX', mask: 'pattern', name: 'Country Name' }
     * 
     * Mask pattern: '_' represents a digit placeholder, other characters are literals
     * Example: '(___) ___-____' formats to '(555) 123-4567'
     */
    window.COUNTRY_PHONE_DATA = {
        // A
        'AF': { flag: '🇦🇫', code: '+93', mask: '__ ___ ____', name: 'Afghanistan' },
        'AL': { flag: '🇦🇱', code: '+355', mask: '__ ___ ____', name: 'Albania' },
        'DZ': { flag: '🇩🇿', code: '+213', mask: '___ __ __ __', name: 'Algeria' },
        'AS': { flag: '🇦🇸', code: '+1684', mask: '___ ____', name: 'American Samoa' },
        'AD': { flag: '🇦🇩', code: '+376', mask: '___ ___', name: 'Andorra' },
        'AO': { flag: '🇦🇴', code: '+244', mask: '___ ___ ___', name: 'Angola' },
        'AI': { flag: '🇦🇮', code: '+1264', mask: '___ ____', name: 'Anguilla' },
        'AQ': { flag: '🇦🇶', code: '+672', mask: '___ ___', name: 'Antarctica' },
        'AG': { flag: '🇦🇬', code: '+1268', mask: '___ ____', name: 'Antigua and Barbuda' },
        'AR': { flag: '🇦🇷', code: '+54', mask: '___ ___-____', name: 'Argentina' },
        'AM': { flag: '🇦🇲', code: '+374', mask: '__ ______', name: 'Armenia' },
        'AW': { flag: '🇦🇼', code: '+297', mask: '___ ____', name: 'Aruba' },
        'AU': { flag: '🇦🇺', code: '+61', mask: '___ ___ ___', name: 'Australia' },
        'AT': { flag: '🇦🇹', code: '+43', mask: '____ _______', name: 'Austria' },
        'AZ': { flag: '🇦🇿', code: '+994', mask: '__ ___ __ __', name: 'Azerbaijan' },
        
        // B
        'BS': { flag: '🇧🇸', code: '+1242', mask: '___ ____', name: 'Bahamas' },
        'BH': { flag: '🇧🇭', code: '+973', mask: '____ ____', name: 'Bahrain' },
        'BD': { flag: '🇧🇩', code: '+880', mask: '____ ______', name: 'Bangladesh' },
        'BB': { flag: '🇧🇧', code: '+1246', mask: '___ ____', name: 'Barbados' },
        'BY': { flag: '🇧🇾', code: '+375', mask: '__ ___ ____', name: 'Belarus' },
        'BE': { flag: '🇧🇪', code: '+32', mask: '___ __ __ __', name: 'Belgium' },
        'BZ': { flag: '🇧🇿', code: '+501', mask: '___ ____', name: 'Belize' },
        'BJ': { flag: '🇧🇯', code: '+229', mask: '__ __ __ __', name: 'Benin' },
        'BM': { flag: '🇧🇲', code: '+1441', mask: '___ ____', name: 'Bermuda' },
        'BT': { flag: '🇧🇹', code: '+975', mask: '__ __ __ __', name: 'Bhutan' },
        'BO': { flag: '🇧🇴', code: '+591', mask: '__ _______', name: 'Bolivia' },
        'BQ': { flag: '🇧🇶', code: '+599', mask: '___ ____', name: 'Bonaire, Sint Eustatius and Saba' },
        'BA': { flag: '🇧🇦', code: '+387', mask: '__ ___ ___', name: 'Bosnia and Herzegovina' },
        'BW': { flag: '🇧🇼', code: '+267', mask: '__ ___ ___', name: 'Botswana' },
        'BR': { flag: '🇧🇷', code: '+55', mask: '(__) _____-____', name: 'Brazil' },
        'IO': { flag: '🇮🇴', code: '+246', mask: '___ ____', name: 'British Indian Ocean Territory' },
        'BN': { flag: '🇧🇳', code: '+673', mask: '___ ____', name: 'Brunei' },
        'BG': { flag: '🇧🇬', code: '+359', mask: '___ ___ ___', name: 'Bulgaria' },
        'BF': { flag: '🇧🇫', code: '+226', mask: '__ __ __ __', name: 'Burkina Faso' },
        'BI': { flag: '🇧🇮', code: '+257', mask: '__ __ __ __', name: 'Burundi' },
        
        // C
        'CV': { flag: '🇨🇻', code: '+238', mask: '___ __ __', name: 'Cabo Verde' },
        'KH': { flag: '🇰🇭', code: '+855', mask: '__ ___ ____', name: 'Cambodia' },
        'CM': { flag: '🇨🇲', code: '+237', mask: '____ ____', name: 'Cameroon' },
        'CA': { flag: '🇨🇦', code: '+1', mask: '(___) ___-____', name: 'Canada' },
        'KY': { flag: '🇰🇾', code: '+1345', mask: '___ ____', name: 'Cayman Islands' },
        'CF': { flag: '🇨🇫', code: '+236', mask: '__ __ __ __', name: 'Central African Republic' },
        'TD': { flag: '🇹🇩', code: '+235', mask: '__ __ __ __', name: 'Chad' },
        'CL': { flag: '🇨🇱', code: '+56', mask: '_ ____ ____', name: 'Chile' },
        'CN': { flag: '🇨🇳', code: '+86', mask: '___ ____ ____', name: 'China' },
        'CX': { flag: '🇨🇽', code: '+61', mask: '___ ___ ___', name: 'Christmas Island' },
        'CC': { flag: '🇨🇨', code: '+61', mask: '___ ___ ___', name: 'Cocos (Keeling) Islands' },
        'CO': { flag: '🇨🇴', code: '+57', mask: '___ _______', name: 'Colombia' },
        'KM': { flag: '🇰🇲', code: '+269', mask: '___ __ __', name: 'Comoros' },
        'CG': { flag: '🇨🇬', code: '+242', mask: '__ ___ ____', name: 'Congo' },
        'CD': { flag: '🇨🇩', code: '+243', mask: '__ ___ ____', name: 'Congo (Democratic Republic)' },
        'CK': { flag: '🇨🇰', code: '+682', mask: '__ ___', name: 'Cook Islands' },
        'CR': { flag: '🇨🇷', code: '+506', mask: '____ ____', name: 'Costa Rica' },
        'CI': { flag: '🇨🇮', code: '+225', mask: '__ __ __ __', name: 'Ivory Coast' },
        'HR': { flag: '🇭🇷', code: '+385', mask: '__ ___ ____', name: 'Croatia' },
        'CU': { flag: '🇨🇺', code: '+53', mask: '_ _______', name: 'Cuba' },
        'CW': { flag: '🇨🇼', code: '+599', mask: '___ ____', name: 'Curaçao' },
        'CY': { flag: '🇨🇾', code: '+357', mask: '__ ______', name: 'Cyprus' },
        'CZ': { flag: '🇨🇿', code: '+420', mask: '___ ___ ___', name: 'Czech Republic' },
        
        // D
        'DK': { flag: '🇩🇰', code: '+45', mask: '__ __ __ __', name: 'Denmark' },
        'DJ': { flag: '🇩🇯', code: '+253', mask: '__ __ __ __', name: 'Djibouti' },
        'DM': { flag: '🇩🇲', code: '+1767', mask: '___ ____', name: 'Dominica' },
        'DO': { flag: '🇩🇴', code: '+1809', mask: '___ ____', name: 'Dominican Republic' },
        
        // E
        'EC': { flag: '🇪🇨', code: '+593', mask: '__ ___ ____', name: 'Ecuador' },
        'EG': { flag: '🇪🇬', code: '+20', mask: '___ ___ ____', name: 'Egypt' },
        'SV': { flag: '🇸🇻', code: '+503', mask: '____ ____', name: 'El Salvador' },
        'GQ': { flag: '🇬🇶', code: '+240', mask: '___ ___ ___', name: 'Equatorial Guinea' },
        'ER': { flag: '🇪🇷', code: '+291', mask: '_ ___ ___', name: 'Eritrea' },
        'EE': { flag: '🇪🇪', code: '+372', mask: '____ ____', name: 'Estonia' },
        'SZ': { flag: '🇸🇿', code: '+268', mask: '__ __ ____', name: 'Eswatini' },
        'ET': { flag: '🇪🇹', code: '+251', mask: '___ ___ ____', name: 'Ethiopia' },
        
        // F
        'FK': { flag: '🇫🇰', code: '+500', mask: '_____', name: 'Falkland Islands' },
        'FO': { flag: '🇫🇴', code: '+298', mask: '______', name: 'Faroe Islands' },
        'FJ': { flag: '🇫🇯', code: '+679', mask: '___ ____', name: 'Fiji' },
        'FI': { flag: '🇫🇮', code: '+358', mask: '___ _______', name: 'Finland' },
        'FR': { flag: '🇫🇷', code: '+33', mask: '_ __ __ __ __', name: 'France' },
        'GF': { flag: '🇬🇫', code: '+594', mask: '___ __ __ __', name: 'French Guiana' },
        'PF': { flag: '🇵🇫', code: '+689', mask: '__ __ __', name: 'French Polynesia' },
        
        // G
        'GA': { flag: '🇬🇦', code: '+241', mask: '_ __ __ __', name: 'Gabon' },
        'GM': { flag: '🇬🇲', code: '+220', mask: '___ ____', name: 'Gambia' },
        'GE': { flag: '🇬🇪', code: '+995', mask: '___ __ __ __', name: 'Georgia' },
        'DE': { flag: '🇩🇪', code: '+49', mask: '____ ________', name: 'Germany' },
        'GH': { flag: '🇬🇭', code: '+233', mask: '___ ___ ____', name: 'Ghana' },
        'GI': { flag: '🇬🇮', code: '+350', mask: '______', name: 'Gibraltar' },
        'GR': { flag: '🇬🇷', code: '+30', mask: '___ ___ ____', name: 'Greece' },
        'GL': { flag: '🇬🇱', code: '+299', mask: '__ __ __', name: 'Greenland' },
        'GD': { flag: '🇬🇩', code: '+1473', mask: '___ ____', name: 'Grenada' },
        'GP': { flag: '🇬🇵', code: '+590', mask: '___ __ __ __', name: 'Guadeloupe' },
        'GU': { flag: '🇬🇺', code: '+1671', mask: '___ ____', name: 'Guam' },
        'GT': { flag: '🇬🇹', code: '+502', mask: '____ ____', name: 'Guatemala' },
        'GG': { flag: '🇬🇬', code: '+44', mask: '____ ______', name: 'Guernsey' },
        'GN': { flag: '🇬🇳', code: '+224', mask: '___ __ __ __', name: 'Guinea' },
        'GW': { flag: '🇬🇼', code: '+245', mask: '___ ___ ___', name: 'Guinea-Bissau' },
        'GY': { flag: '🇬🇾', code: '+592', mask: '___ ____', name: 'Guyana' },
        
        // H
        'HT': { flag: '🇭🇹', code: '+509', mask: '__ __ ____', name: 'Haiti' },
        'VA': { flag: '🇻🇦', code: '+39', mask: '__ ____ ____', name: 'Vatican City' },
        'HN': { flag: '🇭🇳', code: '+504', mask: '____ ____', name: 'Honduras' },
        'HK': { flag: '🇭🇰', code: '+852', mask: '____ ____', name: 'Hong Kong' },
        'HU': { flag: '🇭🇺', code: '+36', mask: '__ ___ ____', name: 'Hungary' },
        
        // I
        'IS': { flag: '🇮🇸', code: '+354', mask: '___ ____', name: 'Iceland' },
        'IN': { flag: '🇮🇳', code: '+91', mask: '_____ _____', name: 'India' },
        'ID': { flag: '🇮🇩', code: '+62', mask: '___ ___-____', name: 'Indonesia' },
        'IR': { flag: '🇮🇷', code: '+98', mask: '___ ___ ____', name: 'Iran' },
        'IQ': { flag: '🇮🇶', code: '+964', mask: '___ ___ ____', name: 'Iraq' },
        'IE': { flag: '🇮🇪', code: '+353', mask: '___ ___ ____', name: 'Ireland' },
        'IM': { flag: '🇮🇲', code: '+44', mask: '____ ______', name: 'Isle of Man' },
        'IL': { flag: '🇮🇱', code: '+972', mask: '___ ___ ____', name: 'Israel' },
        'IT': { flag: '🇮🇹', code: '+39', mask: '___ ___ ____', name: 'Italy' },
        
        // J
        'JM': { flag: '🇯🇲', code: '+1876', mask: '___ ____', name: 'Jamaica' },
        'JP': { flag: '🇯🇵', code: '+81', mask: '___ ____-____', name: 'Japan' },
        'JE': { flag: '🇯🇪', code: '+44', mask: '____ ______', name: 'Jersey' },
        'JO': { flag: '🇯🇴', code: '+962', mask: '_ ____ ____', name: 'Jordan' },
        
        // K
        'KZ': { flag: '🇰🇿', code: '+7', mask: '___ ___ __ __', name: 'Kazakhstan' },
        'KE': { flag: '🇰🇪', code: '+254', mask: '___ ______', name: 'Kenya' },
        'KI': { flag: '🇰🇮', code: '+686', mask: '________', name: 'Kiribati' },
        'KP': { flag: '🇰🇵', code: '+850', mask: '___ ___ ____', name: 'North Korea' },
        'KR': { flag: '🇰🇷', code: '+82', mask: '___ ____-____', name: 'South Korea' },
        'XK': { flag: '🇽🇰', code: '+383', mask: '__ ___ ___', name: 'Kosovo' },
        'KW': { flag: '🇰🇼', code: '+965', mask: '____ ____', name: 'Kuwait' },
        'KG': { flag: '🇰🇬', code: '+996', mask: '___ ______', name: 'Kyrgyzstan' },
        
        // L
        'LA': { flag: '🇱🇦', code: '+856', mask: '__ __ ___ ___', name: 'Laos' },
        'LV': { flag: '🇱🇻', code: '+371', mask: '__ ___ ___', name: 'Latvia' },
        'LB': { flag: '🇱🇧', code: '+961', mask: '__ ___ ___', name: 'Lebanon' },
        'LS': { flag: '🇱🇸', code: '+266', mask: '__ ___ ___', name: 'Lesotho' },
        'LR': { flag: '🇱🇷', code: '+231', mask: '__ ___ ____', name: 'Liberia' },
        'LY': { flag: '🇱🇾', code: '+218', mask: '__ _______', name: 'Libya' },
        'LI': { flag: '🇱🇮', code: '+423', mask: '___ ___ ___', name: 'Liechtenstein' },
        'LT': { flag: '🇱🇹', code: '+370', mask: '___ _____', name: 'Lithuania' },
        'LU': { flag: '🇱🇺', code: '+352', mask: '___ ___ ___', name: 'Luxembourg' },
        
        // M
        'MO': { flag: '🇲🇴', code: '+853', mask: '____ ____', name: 'Macau' },
        'MG': { flag: '🇲🇬', code: '+261', mask: '__ __ ___ __', name: 'Madagascar' },
        'MW': { flag: '🇲🇼', code: '+265', mask: '__ ___ ____', name: 'Malawi' },
        'MY': { flag: '🇲🇾', code: '+60', mask: '___ ___ ____', name: 'Malaysia' },
        'MV': { flag: '🇲🇻', code: '+960', mask: '___ ____', name: 'Maldives' },
        'ML': { flag: '🇲🇱', code: '+223', mask: '__ __ __ __', name: 'Mali' },
        'MT': { flag: '🇲🇹', code: '+356', mask: '____ ____', name: 'Malta' },
        'MH': { flag: '🇲🇭', code: '+692', mask: '___ ____', name: 'Marshall Islands' },
        'MQ': { flag: '🇲🇶', code: '+596', mask: '___ __ __ __', name: 'Martinique' },
        'MR': { flag: '🇲🇷', code: '+222', mask: '__ __ __ __', name: 'Mauritania' },
        'MU': { flag: '🇲🇺', code: '+230', mask: '____ ____', name: 'Mauritius' },
        'YT': { flag: '🇾🇹', code: '+262', mask: '___ __ __ __', name: 'Mayotte' },
        'MX': { flag: '🇲🇽', code: '+52', mask: '___ ___ ____', name: 'Mexico' },
        'FM': { flag: '🇫🇲', code: '+691', mask: '___ ____', name: 'Micronesia' },
        'MD': { flag: '🇲🇩', code: '+373', mask: '____ ____', name: 'Moldova' },
        'MC': { flag: '🇲🇨', code: '+377', mask: '__ __ __ __', name: 'Monaco' },
        'MN': { flag: '🇲🇳', code: '+976', mask: '__ __ ____', name: 'Mongolia' },
        'ME': { flag: '🇲🇪', code: '+382', mask: '__ ___ ___', name: 'Montenegro' },
        'MS': { flag: '🇲🇸', code: '+1664', mask: '___ ____', name: 'Montserrat' },
        'MA': { flag: '🇲🇦', code: '+212', mask: '___ ______', name: 'Morocco' },
        'MZ': { flag: '🇲🇿', code: '+258', mask: '__ ___ ____', name: 'Mozambique' },
        'MM': { flag: '🇲🇲', code: '+95', mask: '__ ___ ____', name: 'Myanmar' },
        
        // N
        'NA': { flag: '🇳🇦', code: '+264', mask: '__ ___ ____', name: 'Namibia' },
        'NR': { flag: '🇳🇷', code: '+674', mask: '___ ____', name: 'Nauru' },
        'NP': { flag: '🇳🇵', code: '+977', mask: '___ _______', name: 'Nepal' },
        'NL': { flag: '🇳🇱', code: '+31', mask: '__ ________', name: 'Netherlands' },
        'NC': { flag: '🇳🇨', code: '+687', mask: '__ __ __', name: 'New Caledonia' },
        'NZ': { flag: '🇳🇿', code: '+64', mask: '___ ___ ____', name: 'New Zealand' },
        'NI': { flag: '🇳🇮', code: '+505', mask: '____ ____', name: 'Nicaragua' },
        'NE': { flag: '🇳🇪', code: '+227', mask: '__ __ __ __', name: 'Niger' },
        'NG': { flag: '🇳🇬', code: '+234', mask: '___ ___ ____', name: 'Nigeria' },
        'NU': { flag: '🇳🇺', code: '+683', mask: '____', name: 'Niue' },
        'NF': { flag: '🇳🇫', code: '+672', mask: '__ ____', name: 'Norfolk Island' },
        'MP': { flag: '🇲🇵', code: '+1670', mask: '___ ____', name: 'Northern Mariana Islands' },
        'MK': { flag: '🇲🇰', code: '+389', mask: '__ ___ ___', name: 'North Macedonia' },
        'NO': { flag: '🇳🇴', code: '+47', mask: '___ __ ___', name: 'Norway' },
        
        // O
        'OM': { flag: '🇴🇲', code: '+968', mask: '____ ____', name: 'Oman' },
        
        // P
        'PK': { flag: '🇵🇰', code: '+92', mask: '___ _______', name: 'Pakistan' },
        'PW': { flag: '🇵🇼', code: '+680', mask: '___ ____', name: 'Palau' },
        'PS': { flag: '🇵🇸', code: '+970', mask: '___ ___ ___', name: 'Palestine' },
        'PA': { flag: '🇵🇦', code: '+507', mask: '____ ____', name: 'Panama' },
        'PG': { flag: '🇵🇬', code: '+675', mask: '___ ____', name: 'Papua New Guinea' },
        'PY': { flag: '🇵🇾', code: '+595', mask: '___ _______', name: 'Paraguay' },
        'PE': { flag: '🇵🇪', code: '+51', mask: '___ ___ ___', name: 'Peru' },
        'PH': { flag: '🇵🇭', code: '+63', mask: '___ ___ ____', name: 'Philippines' },
        'PN': { flag: '🇵🇳', code: '+64', mask: '__ ___', name: 'Pitcairn Islands' },
        'PL': { flag: '🇵🇱', code: '+48', mask: '___ ___ ___', name: 'Poland' },
        'PT': { flag: '🇵🇹', code: '+351', mask: '___ ___ ___', name: 'Portugal' },
        'PR': { flag: '🇵🇷', code: '+1787', mask: '___ ____', name: 'Puerto Rico' },
        
        // Q
        'QA': { flag: '🇶🇦', code: '+974', mask: '____ ____', name: 'Qatar' },
        
        // R
        'RE': { flag: '🇷🇪', code: '+262', mask: '___ __ __ __', name: 'Réunion' },
        'RO': { flag: '🇷🇴', code: '+40', mask: '___ ___ ____', name: 'Romania' },
        'RU': { flag: '🇷🇺', code: '+7', mask: '(___) ___-__-__', name: 'Russia' },
        'RW': { flag: '🇷🇼', code: '+250', mask: '___ ___ ___', name: 'Rwanda' },
        
        // S
        'BL': { flag: '🇧🇱', code: '+590', mask: '___ __ __ __', name: 'Saint Barthélemy' },
        'SH': { flag: '🇸🇭', code: '+290', mask: '____', name: 'Saint Helena' },
        'KN': { flag: '🇰🇳', code: '+1869', mask: '___ ____', name: 'Saint Kitts and Nevis' },
        'LC': { flag: '🇱🇨', code: '+1758', mask: '___ ____', name: 'Saint Lucia' },
        'MF': { flag: '🇲🇫', code: '+590', mask: '___ __ __ __', name: 'Saint Martin' },
        'PM': { flag: '🇵🇲', code: '+508', mask: '__ __ __', name: 'Saint Pierre and Miquelon' },
        'VC': { flag: '🇻🇨', code: '+1784', mask: '___ ____', name: 'Saint Vincent and the Grenadines' },
        'WS': { flag: '🇼🇸', code: '+685', mask: '__ ____', name: 'Samoa' },
        'SM': { flag: '🇸🇲', code: '+378', mask: '____ ______', name: 'San Marino' },
        'ST': { flag: '🇸🇹', code: '+239', mask: '___ ____', name: 'São Tomé and Príncipe' },
        'SA': { flag: '🇸🇦', code: '+966', mask: '___ ___ ____', name: 'Saudi Arabia' },
        'SN': { flag: '🇸🇳', code: '+221', mask: '__ ___ __ __', name: 'Senegal' },
        'RS': { flag: '🇷🇸', code: '+381', mask: '__ _______', name: 'Serbia' },
        'SC': { flag: '🇸🇨', code: '+248', mask: '_ ___ ___', name: 'Seychelles' },
        'SL': { flag: '🇸🇱', code: '+232', mask: '__ ______', name: 'Sierra Leone' },
        'SG': { flag: '🇸🇬', code: '+65', mask: '____ ____', name: 'Singapore' },
        'SX': { flag: '🇸🇽', code: '+1721', mask: '___ ____', name: 'Sint Maarten' },
        'SK': { flag: '🇸🇰', code: '+421', mask: '___ ___ ___', name: 'Slovakia' },
        'SI': { flag: '🇸🇮', code: '+386', mask: '__ ___ ___', name: 'Slovenia' },
        'SB': { flag: '🇸🇧', code: '+677', mask: '__ _____', name: 'Solomon Islands' },
        'SO': { flag: '🇸🇴', code: '+252', mask: '__ _______', name: 'Somalia' },
        'ZA': { flag: '🇿🇦', code: '+27', mask: '___ ___ ____', name: 'South Africa' },
        'GS': { flag: '🇬🇸', code: '+500', mask: '_____', name: 'South Georgia' },
        'SS': { flag: '🇸🇸', code: '+211', mask: '___ ___ ___', name: 'South Sudan' },
        'ES': { flag: '🇪🇸', code: '+34', mask: '___ ___ ___', name: 'Spain' },
        'LK': { flag: '🇱🇰', code: '+94', mask: '__ ___ ____', name: 'Sri Lanka' },
        'SD': { flag: '🇸🇩', code: '+249', mask: '__ ___ ____', name: 'Sudan' },
        'SR': { flag: '🇸🇷', code: '+597', mask: '___ ____', name: 'Suriname' },
        'SJ': { flag: '🇸🇯', code: '+47', mask: '__ __ __ __', name: 'Svalbard and Jan Mayen' },
        'SE': { flag: '🇸🇪', code: '+46', mask: '___ ___ ___', name: 'Sweden' },
        'CH': { flag: '🇨🇭', code: '+41', mask: '__ ___ __ __', name: 'Switzerland' },
        'SY': { flag: '🇸🇾', code: '+963', mask: '___ ___ ___', name: 'Syria' },
        
        // T
        'TW': { flag: '🇹🇼', code: '+886', mask: '___ ___ ___', name: 'Taiwan' },
        'TJ': { flag: '🇹🇯', code: '+992', mask: '___ __ ____', name: 'Tajikistan' },
        'TZ': { flag: '🇹🇿', code: '+255', mask: '___ ___ ___', name: 'Tanzania' },
        'TH': { flag: '🇹🇭', code: '+66', mask: '___ ___ ____', name: 'Thailand' },
        'TL': { flag: '🇹🇱', code: '+670', mask: '___ ____', name: 'Timor-Leste' },
        'TG': { flag: '🇹🇬', code: '+228', mask: '__ __ __ __', name: 'Togo' },
        'TK': { flag: '🇹🇰', code: '+690', mask: '____', name: 'Tokelau' },
        'TO': { flag: '🇹🇴', code: '+676', mask: '__ ___', name: 'Tonga' },
        'TT': { flag: '🇹🇹', code: '+1868', mask: '___ ____', name: 'Trinidad and Tobago' },
        'TN': { flag: '🇹🇳', code: '+216', mask: '__ ___ ___', name: 'Tunisia' },
        'TR': { flag: '🇹🇷', code: '+90', mask: '___ ___ __ __', name: 'Turkey' },
        'TM': { flag: '🇹🇲', code: '+993', mask: '__ ______', name: 'Turkmenistan' },
        'TC': { flag: '🇹🇨', code: '+1649', mask: '___ ____', name: 'Turks and Caicos Islands' },
        'TV': { flag: '🇹🇻', code: '+688', mask: '__ ____', name: 'Tuvalu' },
        
        // U
        'UG': { flag: '🇺🇬', code: '+256', mask: '___ ______', name: 'Uganda' },
        'UA': { flag: '🇺🇦', code: '+380', mask: '___ ___ ____', name: 'Ukraine' },
        'AE': { flag: '🇦🇪', code: '+971', mask: '___ ___ ____', name: 'United Arab Emirates' },
        'GB': { flag: '🇬🇧', code: '+44', mask: '____ ______', name: 'United Kingdom' },
        'US': { flag: '🇺🇸', code: '+1', mask: '(___) ___-____', name: 'United States' },
        'UM': { flag: '🇺🇲', code: '+1', mask: '___ ____', name: 'U.S. Minor Outlying Islands' },
        'UY': { flag: '🇺🇾', code: '+598', mask: '__ ___ ___', name: 'Uruguay' },
        'UZ': { flag: '🇺🇿', code: '+998', mask: '__ ___ __ __', name: 'Uzbekistan' },
        
        // V
        'VU': { flag: '🇻🇺', code: '+678', mask: '__ _____', name: 'Vanuatu' },
        'VE': { flag: '🇻🇪', code: '+58', mask: '___ _______', name: 'Venezuela' },
        'VN': { flag: '🇻🇳', code: '+84', mask: '___ ___ ____', name: 'Vietnam' },
        'VG': { flag: '🇻🇬', code: '+1284', mask: '___ ____', name: 'British Virgin Islands' },
        'VI': { flag: '🇻🇮', code: '+1340', mask: '___ ____', name: 'U.S. Virgin Islands' },
        
        // W
        'WF': { flag: '🇼🇫', code: '+681', mask: '__ __ __', name: 'Wallis and Futuna' },
        'EH': { flag: '🇪🇭', code: '+212', mask: '___ ______', name: 'Western Sahara' },
        
        // Y
        'YE': { flag: '🇾🇪', code: '+967', mask: '___ ___ ___', name: 'Yemen' },
        
        // Z
        'ZM': { flag: '🇿🇲', code: '+260', mask: '__ _______', name: 'Zambia' },
        'ZW': { flag: '🇿🇼', code: '+263', mask: '__ ___ ____', name: 'Zimbabwe' },
    };

    /**
     * Get country data by country code
     * @param {string} countryCode - ISO country code (e.g., 'US', 'GB')
     * @returns {Object|null} Country data or null if not found
     */
    window.getCountryPhoneData = function(countryCode) {
        return window.COUNTRY_PHONE_DATA[countryCode] || null;
    };

    /**
     * Get country data by phone code
     * @param {string} phoneCode - International phone code (e.g., '+1', '+44')
     * @returns {Object|null} Country data or null if not found
     */
    window.getCountryByPhoneCode = function(phoneCode) {
        for (const countryCode in window.COUNTRY_PHONE_DATA) {
            if (window.COUNTRY_PHONE_DATA[countryCode].code === phoneCode) {
                return window.COUNTRY_PHONE_DATA[countryCode];
            }
        }
        return null;
    };

    /**
     * Search countries by name
     * @param {string} searchTerm - Search term
     * @returns {Array} Array of matching country data with country codes
     */
    window.searchCountries = function(searchTerm) {
        const term = searchTerm.toLowerCase();
        const results = [];
        
        for (const countryCode in window.COUNTRY_PHONE_DATA) {
            const country = window.COUNTRY_PHONE_DATA[countryCode];
            if (country.name.toLowerCase().includes(term)) {
                results.push({
                    countryCode: countryCode,
                    ...country
                });
            }
        }
        
        return results;
    };

})();
